$html = $('html')
$body = $('body')
$mobileModal = $('.col-mobile-modal')
$header = $('header')

$body.on('click', '#mobile-menu-toggle', function (e) {
  $header.toggleClass('mobile-open')
});

$body.on('click', '.has-sublinks button', function (e) {
  const sublinks = $(this).closest('.has-sublinks')
  if(sublinks) {
    sublinks.toggleClass('is-open')
  }
})

window.addEventListener("click", (e) => {

  if ($(e.target).closest('.has-sublinks').length === 0) {
    $('.has-sublinks').removeClass('is-open');
  }

})
